import { useTranslation } from 'react-i18next';
import { Textfield } from '@digdir/designsystemet-react';

import { ByggType } from '../../../../../../components/registering/utils/registerEnums';
import { useOmBoligenFormContext } from '../utils';
import { useOmBoligenValidation } from '../hooks/useOmBoligenValidation';

export const AntallEtasjerInput = () => {
  const { t } = useTranslation();
  const { register, watch, formState } = useOmBoligenFormContext();
  const { validateEtasjer } = useOmBoligenValidation();

  const error = formState.errors.bygginfo?.floors?.message;
  const byggType = watch('bygginfo.byggtype');
  const labelKey =
    byggType === ByggType.Leilighet
      ? 'register.bygningsdetaljer.leilighet.antallEtasjerUnntattKjeller.label'
      : 'register.bygningsdetaljer.antallEtasjerUnntattKjeller.label';

  return (
    <Textfield
      type="text"
      inputMode="numeric"
      label={t(labelKey)}
      error={error}
      {...register('bygginfo.floors', {
        validate: validateEtasjer,
        pattern: {
          value: /^\d+$/,
          message: t('form.error.integer')
        }
      })}
    />
  );
};
